import PropTypes from 'prop-types';
import React from 'react';
import { APP_URLS } from '../../utils/appUrls';
import { CONTACTS } from '../../utils/imports';

const ConfirmationFaq = ({ hasTeraResponse, hasHighCompensation }) => (
  <>
    <section className="hca-confirmation-faq">
      <h2 className="vads-u-font-size--h3">What to expect next</h2>
      <p>
        We typically process healthcare applications within a week. We’ll send
        you a letter in the mail with our decision.
      </p>
      <p className="screen-only">
        <va-link
          text="Learn more about what happens after you apply"
          href="/health-care/after-you-apply/"
        />
      </p>
    </section>

    <section className="hca-confirmation-faq">
      <h2 className="vads-u-font-size--h3">
        If you want to check the status of your application
      </h2>
      <p>
        Sign in and go back to the healthcare application introduction page.
        You’ll find your application status at the top of the page.
      </p>
      <p className="screen-only">
        <va-link-action
          text="Check the status of your application"
          href={APP_URLS.hca}
        />
      </p>
    </section>

    {hasTeraResponse && (
      <section className="hca-confirmation-faq" data-testid="hca-tera-faq">
        <h2 className="vads-u-font-size--h3">
          If you want to submit documents to support your military service
          history
        </h2>
        <p>
          You can mail us a written statement to confirm your exposure to any
          toxins or other hazards during military service. It’s your choice
          whether to submit a statement.
        </p>
        <p>Here’s what you can include in your statement:</p>
        <ul>
          <li>
            Any toxins or hazards you were exposed to while you were deployed or
            during active-duty training or service
          </li>
          <li>Month and year when you were exposed</li>
          <li>
            Type of activity or work you were doing when you were exposed (like
            basic training)
          </li>
        </ul>
        <p>
          And you’ll need to write your name and Social Security number on your
          statement.
        </p>
        <p>Mail your documents to this address:</p>
        <address className="va-address-block">
          Health Eligibility Center
          <br role="presentation" />
          PO Box 5207
          <br role="presentation" />
          Janesville, WI 53547-5207
        </address>
      </section>
    )}

    {hasHighCompensation && (
      <section className="hca-confirmation-faq" data-testid="hca-champva-faq">
        <h2 className="vads-u-font-size--h3">
          If your family wants to apply for CHAMPVA benefits
        </h2>
        <p>
          Since you have a service-connected disability rating of 50% or higher,
          your family may be eligible for healthcare benefits through CHAMPVA.
        </p>
        <p className="screen-only">
          <va-link
            text="Learn more about CHAMPVA benefits"
            href="/family-and-caregiver-benefits/health-and-disability/champva/"
          />
        </p>
      </section>
    )}

    <section className="hca-confirmation-faq">
      <h2 className="vads-u-font-size--h3">
        How to contact us about your application
      </h2>
      <p>
        If you have any questions about your application, call our toll-free
        hotline at <va-telephone contact={CONTACTS['222_VETS']} /> (
        <va-telephone contact={CONTACTS['711']} tty />
        ). We’re here Monday through Friday, 8:00 a.m. to 8:00 p.m.{' '}
        <dfn>
          <abbr title="Eastern Time">ET</abbr>
        </dfn>
        .
      </p>
      <p>You can also use Ask VA to ask questions online.</p>
      <p className="screen-only">
        <va-link text="Go to Ask VA" href={APP_URLS.askVa} />
      </p>
    </section>
  </>
);

ConfirmationFaq.propTypes = {
  hasHighCompensation: PropTypes.bool,
  hasTeraResponse: PropTypes.bool,
};

export default ConfirmationFaq;
